export default {
    en: {
        message: {
            yes: 'yes',
            no: 'no',
            hello: 'hello world',
            instruction: 'instructions',
            practiceAborted: 'Practice aborted',
            completed: 'Completed',
            practice: 'Practice',
            test: 'Main task',
            continue: 'Continue',
            pressContinuePractice: 'Press continue to start the practice round.',
            pressContinueTest: 'Press continue to start.',
            abort: 'Exit task',
            retryTitle: 'Another round of practice',
            retryText: 'To ensure that you understand the task, the practice continues with a few more exercises.',
            trainingCompleted: 'Training completed!',
            trainingCompletedInfo: 'Press continue to start the main task',
            noFeedback: 'You will not get feedback on your responses.',
            feedback: 'You will get feedback on the screen if you do it correctly or not.',
            recall: 'Recall',
            delayed: 'Delayed recall',
            recognition: 'Recognition',
            // Test names
            dsf: 'Digit Span Forward',
            dsb: 'Digit Span Backward',
            cod: 'Symbol-Digit Challenge',
            vm: 'Memory for Words',
            vismem: 'Where Was What?',
            srt: 'Simple Reaction Time',
            srtaudio: 'Reaction Time with Sound',
            crt: 'Reaction Time with a Twist',
            mst: 'Picture Memory',
            pvt: 'Word Task',
            mat: 'Matrix Test',
            hads: 'Hospital Anxiety and Depression Scale',
            asrs: 'Adult ADHD Self-Report Scale',
            uppsp: 'Impulsive Behavior Scale',
            russug: 'Check-in',
            cobra: 'Cognitive Function Questions',
            audit: 'Alcohol Questions',
            dudit: 'Substance Use Questions',
            pretest: 'Before We Start',
            posttest: 'At the Very End',
            pretestfatigue: 'Before We Start',
            posttestfatigue: 'At the Very End',
            breakpoint: 'Information for Participant',
            matrix: 'Complete the pattern',
            cpt: 'Continuous Performance Test',
            stroop: 'Color Game',
            stroope: 'Color Game Emotional',
            cpfsurvey: 'A Few Short Questions',
            rand36: 'Questions About Your Health',
            addiqol: 'Survey',
            ant: 'Attention Test',
            cptms: 'Continuous Performance Test',
            cpt10: 'Continuous Performance Test',
            pst: 'Memory for Pictures',
            shortpersonalitytest: 'Short Personality Test',
            personalitytest: 'Personality Test',
            grit: 'Perseverance',
            rewardandpunishment: 'Reward and Punishment',
            bwsurvey: 'Questions About Birth Weight',
            birthweightsurvey: 'Questions About Birth Weight',
            fingertappingtest: 'Speed Test',
            cptaudio: 'Listen closely',
            cptaudio7: 'Listen closely',
            rrq: 'Thinking Patterns',
            rrs: 'Thought Scale',
            synsoppfatningBlokk: 'Visual Perception',
            synsoppfatningBlokkMulti: 'Visual Perception',
            synsoppfatningEvent: 'Visual Perception',
            psst: 'PSST',
            ders: 'DERS',
            mrt: 'Mental Rotation',
            survey: 'Survey',
            ptr: 'Pattern Recognition',
            visualPerception: 'What\'s in the Foreground?',
            dotProbe: 'Dot Probe'
        }
    },
    no: {
        message: {
            yes: 'ja',
            no: 'nei',
            hello: 'hei verden',
            instruction: 'Instruksjon',
            practiceAborted: 'Trening avbrutt',
            completed: 'Fullført',
            practice: 'Treningsoppgave',
            test: 'Hovedoppgave',
            continue: 'Fortsett',
            pressContinuePractice: 'Trykk på Fortsett-knappen for å starte treningen.',
            pressContinueTest: 'Trykk på Fortsett-knappen for å starte testen.',
            abort: 'Avbryt oppgave',
            retryTitle: 'En runde til med trening',
            retryText: 'For å sikre at du forstår oppgaven fortsetter treningen med noen flere oppgaver.',
            trainingCompleted: 'Trening fullført!',
            trainingCompletedInfo: 'Trykk på Fortsett-knappen for å starte hovedoppgaven.',
            noFeedback: 'Du får IKKE TILBAKEMELDING når du svarer.',
            feedback: 'Du får tilbakemelding når du svarer.',
            recall: 'Gjenkalling',
            delayed: 'Utsatt gjenkalling',
            recognition: 'Gjenkjenning',
            // Test names
            dsf: 'Tallspenn framlengs',
            dsb: 'Tallspenn baklengs',
            cod: 'Symbol-tall utfordring',
            vm: 'Ord-hukommelse',
            vismem: 'Hvor var hva?',
            srt: 'Enkel reaksjonstid',
            srtaudio: 'Reaksjonstid med lyd',
            crt: 'Reaksjonstid med en vri',
            mst: 'Bildehukommelse',
            pvt: 'Hvilket bilde passer til ordet?',
            mat: 'Matrise Test',
            hads: 'Hospital Anxiety and Depression Scale',
            asrs: 'Adult ADHD Self-Report Scale',
            uppsp: 'Impulsive Behaviour Scale',
            russug: 'Innsjekk',
            cobra: 'Spørsmål om kognitv funksjon',
            audit: 'Spørsmål om alkohol',
            dudit: 'Spørsmål om rusmidler',
            pretest: 'Før vi starter',
            posttest: 'Helt på slutten',
            pretestfatigue: 'Før vi starter',
            posttestfatigue: 'Helt på slutten',
            breakpoint: 'Informasjon til deltaker',
            matrix: 'Finn mønsteret',
            cpt: 'Reaksjonstid med bokstaver',
            stroop: 'Fargelek',
            stroope: 'Fargelek',
            cpfsurvey: 'Noen korte spørsmål',
            rand36: 'Spørsmål om din helse',
            addiqol: 'Spørreundersøkelse',
            ant: 'Pilretning',
            cptms: 'Reaksjonstid med bokstaver',
            cpt10: 'Reaksjonstid med bokstaver',
            pst: 'Like og ulike bilder',
            shortpersonalitytest: 'Kort personlighetstest',
            personalitytest: 'Personlighetstest',
            grit: 'Utholdenhet',
            rewardandpunishment: 'Belønning og straff',
            bwsurvey: 'Spørsmål om fødselsvekt',
            birthweightsurvey: 'Spørsmål om fødselsvekt',
            fingertappingtest: 'Hastighetstest',
            cptaudio: 'Reaksjonstid med lyd',
            cptaudio7: 'Reaksjonstid med lyd',
            rrq: 'Tankemønster',
            rrs: 'Tankeskala',
            synsoppfatningBlokk: 'Synsoppfatning',
            synsoppfatningBlokkMulti: 'Synsoppfatning',
            synsoppfatningEvent: 'Synsoppfatning',
            psst: 'PSST',
            ders: 'DERS',
            mrt: 'Figurlek',
            survey: 'Spørreskjema',
            ptr: 'Mønstergjenkjenning',
            visualPerception: 'What\'s in the Foreground?',
            dotProbe: 'Prikken'
        }
    },
}



// WEBPACK FOOTER //
// ./src/data/translations.js